import { useEffect, useRef } from "react";
import { fetchQuery } from "react-relay";

import documentChangesFromPreviousVersionQuery from "../documentChangesFromPreviousVersionQuery";

import { environment } from "pstat-anywhere/relay";

const useGetChangesForDocument = (
  optionallyLoadChanges,
  documentPk,
  onChangeTaskLoad,
  setCheckingChangesDiff
) => {
  const hasFetchedChanges = useRef(false);
  useEffect(() => {
    if (optionallyLoadChanges && !hasFetchedChanges.current) {
      hasFetchedChanges.current = true;
      setCheckingChangesDiff(true);
      fetchQuery(environment, documentChangesFromPreviousVersionQuery, {
        documentPk
      }).then(data => {
        setCheckingChangesDiff(false);
        const taskId = data.documentChangesFromPreviousVersion?.taskId;
        onChangeTaskLoad(taskId);
      });
    }
  }, [
    optionallyLoadChanges,
    documentPk,
    onChangeTaskLoad,
    setCheckingChangesDiff
  ]);
};

export default useGetChangesForDocument;
